import { connect } from 'react-redux';
import Urls from './Urls';

const mapStateToProps = (state: any) => ({
  appTrackerSettings: state.trackerSettings.app.settings,
});

export default connect(mapStateToProps, null)(Urls);
